module.exports = __webpack_public_path__ + "static/media/instagram_orange.804db24d.svg";